import { NMOS as type } from '@/store/types';
import NationalMemberOrganizations from '@/services/Api/NationalMemberOrganizations';

const state = {
  data: [],
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
};

const actions = {
  async fetchNMOs({ commit }) {
    commit(type.LOADING, true);

    try {
      const response = await NationalMemberOrganizations.all();
      const { status, data } = response.data;

      if (status === 200) {
        commit(type.SET, data);
        return data;
      }

      return [];
    } finally {
      commit(type.LOADING, false);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
